import { ClientContactDTO, ClientDTO } from 'wisestep-api';

import { DirectHireClient } from '../types/DirectHireClient';

import { EntityType } from './ClientListingHelper';

export const mergeFetchedClients = (directHireResults: DirectHireClient[]): DirectHireClient => {
  const mergedClient = directHireResults[0];
  if (mergedClient.contacts.length > 0) {
    mergedClient.contacts = mergedClient.contacts.filter(
      (contact) => contact.contactEmail && contact.contactPerson
    );
  }
  return mergedClient;
};

export const createClientPayload = {
  id: '',
  name: '',
  legalName: '',
  timezone: '',
  invoiceCode: '',
  paymentTerms: '',
  address: '',
  description: '',
  createdByName: '',
  branch: '',
  source: '',
  isActive: true,
  createdBy: '',
  createdOn: null,
  businessUnit: null,
  childCount: 0,
  location: null,
  clientContactCount: 0,
  industry: '',
  website: '',
  country: '',
  clientStatusId: '',
  tags: [],
  customFields: null,
  uniqueId: null,
};

export const mapDirectHireClientToClientDTO = (directHireClient: DirectHireClient): ClientDTO => {
  const clientDTO: ClientDTO = {
    ...createClientPayload,
    name: directHireClient.companyName,
    uniqueId: directHireClient.hash,
    linkedinUrl: directHireClient.companyLinkedinUrl,
    industry: directHireClient.industry,
  };
  return clientDTO;
};

export const mapDirectHireClientToClientContactDTO = (
  directHireClient: DirectHireClient
): ClientContactDTO[] => {
  const clientContacts: ClientContactDTO[] = [];
  directHireClient.contacts.forEach((contact) => {
    clientContacts.push({
      id: '',
      firstName: contact.contactPerson ? contact.contactPerson.split(' ')[0] : '',
      emailAddress: contact.contactEmail,
      phoneNumber: contact.contactNumber !== 'NaN' ? contact.contactNumber : '',
      lastName:
        contact.contactPerson && contact.contactPerson.split(' ')[1]
          ? contact.contactPerson.split(' ')[1]
          : '',
      position: '',
      location: null,
      physicalAddress: '',
      linkedinProfile: contact.contactLinkedinUrl !== 'NaN' ? contact.contactLinkedinUrl : '',
      supervisorPosition: '',
      supervisorName: '',
      createdByName: '',
      markStatus: true,
      workspaceId: '',
      clientId: '',
      createdBy: '',
      createdOn: null,
    });
  });
  return clientContacts;
};

export const entityTypeOptions = [
  { label: 'Client', value: EntityType.CLIENT },
  { label: 'Vendor', value: EntityType.VENDOR },
  { label: 'Prospect', value: EntityType.PROSPECT },
];
